import React from 'react';
import moment from 'moment';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Button from '@mui/lab/LoadingButton';
import DateTimePicker from '@mui/lab/DateTimePicker'

import { useMutation, useQueryClient } from 'react-query';
import { useForm, Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { createVacation } from 'api/players';

const VactionDialog: React.FC<DialogProps> = (props) => {
    const { playerId } = useParams();

    const queryClient = useQueryClient();

    const { control, handleSubmit, reset, setValue } = useForm({
        defaultValues: {
            start_datetime: '',
            end_datetime: ''
        }
    });

    const { mutate, isLoading } = useMutation(createVacation, {
        onSuccess: () => {
            queryClient.invalidateQueries(['player-active-vacation', playerId]);

            props.onClose({}, 'backdropClick');

            reset();
        }
    });

    const onSubmit = handleSubmit((data: any) => {
        mutate({
            ...data,
            playerId: playerId,
            start_datetime: data.start_datetime.toISOString(),
            end_datetime: data.end_datetime.toISOString(),
        });
    });

    return (
        <Dialog {...props} maxWidth="sm" fullWidth>
            <DialogTitle>Создать отпуск</DialogTitle>
            <DialogContent>
                <form className="flex flex-col space-y-4 pt-2" onSubmit={onSubmit} noValidate>
                    <Controller
                        name="start_datetime"
                        control={control}
                        render={({ field }) => (
                            <DateTimePicker
                                {...field}
                                renderInput={props => (
                                    <TextField {...props} label="Дата начала" required fullWidth />
                                )}
                            />
                        )}
                    />
                    <Controller
                        name="end_datetime"
                        control={control}
                        render={({ field }) => (
                            <DateTimePicker
                                {...field}
                                renderInput={props => (
                                    <TextField {...props} label="Дата конца" required fullWidth />
                                )}
                            />
                        )}
                    />
                    <div className="pt-4 flex justify-between text-right">
                        <Button
                            size="large"
                            loading={isLoading}
                            onClick={() => setValue('end_datetime', moment().add(10, 'years').toISOString())}
                        >Max</Button>
                        <Button
                            type="submit"
                            variant="contained"
                            size="large"
                            loading={isLoading}
                        >Создать</Button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default VactionDialog;
